import React from 'react';
import { GlowCard } from '../GlowCard';
import { ButtonNew } from '../../ButtonNew';
import { uiConfig } from '../../../app-ui-config';
import styles from './CtaSection.css';

function CtaSection() {
    return (
        <section className={styles.root}>
            <GlowCard className={styles.card}>
                <h2 className={styles.title}>Your story is worth telling. Start today.</h2>
                <p className={styles.subtitle}>Keep it private for as long as you want. Share it with your family whenever you are ready.</p>
                <ButtonNew
                    type='pillSecondary'
                    label='Get started'
                    link={{
                        to: uiConfig.prelanderLink,
                        target: '_blank'
                    }}
                />
            </GlowCard>
        </section>
    );
}

export {
    CtaSection
};
